import clsx from 'clsx';

import { SpinnerIcon } from '@/resources';

type SpinnerProps = React.SVGProps<SVGSVGElement>;

export const Spinner = ({
  fill = 'var(--color-primary-blue)',
  className = 'h-10 w-10',
  ...props
}: SpinnerProps) => (
  <div className={'flex size-full items-center justify-center'}>
    <SpinnerIcon fill={fill} {...props} className={clsx('animate-spin', className)} />
  </div>
);
